import PropTypes from 'prop-types';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';

const UserImage = ({ imageURL = '', width = 38, height = 38, withBorder = false, ...props }) => {
	const commonStyles = {
		width,
		height,
		minWidth: width,
		minHeight: height,
		objectFit: 'cover',
		objectPosition: 'center center',
		display: 'block',
		borderRadius: '50%',
		overflow: 'hidden',
		border: withBorder ? '2px solid #383838' : 'none'
	};

	const iconSize = typeof width === 'number' ? Math.max(Math.round(width * 0.56), 14) : '56%';

	return imageURL ? (
		<img src={imageURL} alt="User Avatar" style={commonStyles} {...props} />
	) : (
		<Avatar
			sx={{
				width,
				height,
				minWidth: width,
				minHeight: height,
				border: withBorder ? '2px solid #383838' : 'none',
				boxSizing: 'border-box',
				backgroundColor: '#D24545',
				color: 'white'
			}}
			{...props}
		>
			<PersonIcon
				sx={{
					width: iconSize,
					height: iconSize,
					fill: 'currentColor'
				}}
			/>
		</Avatar>
	);
};

UserImage.propTypes = {
	imageURL: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
	withBorder: PropTypes.bool
};

export default UserImage;
